/**
 * Overlapping member avatars on a discover card (Figma 10219:24475): up to
 * four 32px Spark Avatars with an 8px overlap, followed by the
 * "Danny, Shimrit, Tolik, Eygeni and 12 more" line.  The "N more" suffix
 * underlines on hover because the whole card opens the members modal.
 */
import React from 'react';
import { Avatar } from '@spark';
import { MAX_STACK_AVATARS, membersSummary, personLabel } from '../../utils/discoverFilters';

export function PersonAvatar({ email, people, size = 'medium', className = '' }) {
    const picture = people?.[email]?.picture;
    const label = personLabel(email, people);
    if (picture) {
        return <Avatar size={size} type="image" src={picture} alt={label} className={className} />;
    }
    return <Avatar size={size} type="initials" primaryText={label} className={className} />;
}

export default function MemberAvatarStack({ emails = [], people = {}, total = 0, max = MAX_STACK_AVATARS }) {
    const { shown, text, more } = membersSummary(emails, people, total, max);
    if (shown.length === 0) {
        return (
            <div className="discover-stack discover-stack--empty" data-testid="discover-member-stack">
                <span className="discover-stack__names">No members yet</span>
            </div>
        );
    }
    return (
        <div className="discover-stack" data-testid="discover-member-stack">
            <div className="discover-stack__avatars" aria-hidden="true">
                {shown.map((email) => (
                    <PersonAvatar key={email} email={email} people={people} className="discover-stack__avatar" />
                ))}
            </div>
            <p className="discover-stack__names" data-testid="discover-member-names">
                {text}
                {more > 0 ? (
                    <>
                        {' and '}
                        <span className="discover-stack__more">{more} more</span>
                    </>
                ) : null}
            </p>
        </div>
    );
}
